import PostRecommended from "./PostRecommended";

export default PostRecommended;
